export const UNAUTHENTICATED_ROUTES = [
	"/", //landing page
	"/login",
	"/forgot-password",
	"/login-otp",
	"/forgot-otp",
	'/account-select',
	'/signup'
];

export const OPEN_ROUTES = [
	"/frequently-asked-questions",
	"/disclaimer",
	"/privacy-policy",
	"/terms-and-conditions",
	"/contact-us",
	"/rights-and-obligations",
];

// If any routing requires a base URL other than the partner's default
export const ROUTE_ENDPOINTS = {
	billing: process.env.PREACT_APP_BILLING_NAVIGATION_ENDPOINT,
	bond_directory: process.env.PREACT_APP_NAVIGATION_ENDPOINT,
	learning_module: process.env.PREACT_APP_NAVIGATION_ENDPOINT,
};

export const UPSTOX_PARTNER_CLIENT_ID = [
	"IBP00930C00",
	"IBP00930C01",
	"IBP00930C02",
	"IBP00930C03",
	"IBP00930C04",
	"IBP00930C05",
	"IBP00930C06",
	"IBP00930C07",
	"IBP00930C08",
	"IBP00930C09",
	"IBP00930C10",
];

export const BAJAJ_PARTNER_CLIENT_ID = [
	"IBP00036I00",
	"IBP00931C00",
	"IBP00932C00"
];

export const STARTS_WITH_PARTNER_IDS=[
	'IBP00932C',
	'IBP00931C',
	'IBP00036I',
    'IBP01230C',
]

export const FUNDSINDIA_PARTNER_CLIENT_ID=['IBP00036I','IBP00932C']
